<template>
  <div class="mt-2">
    <div class="w-full h-full">
      <div class="flex cursor-pointer mb-3" @click="back()">
        <img src="@/assets/icons/backArrow.svg" />
        <div class="self-center text-center text-lg font-semibold grow text-black">Select Payment Method</div>
      </div>
      <RouterLink
        v-if="widgetStore.order.paymentMethods?.creditOrDebitCard"
        class="flex cursor-pointer m-1 h-14"
        :to="{ name: 'PeachPayment', query: { paymentMethod: 'CARD' } }"
      >
        <div class="self-center p-1 w-14">
          <img src="@/assets/paymentMethods/card.svg" />
        </div>
        <div class="self-center text-sm grow text-left text-black">Card Payment</div>
        <div class="self-center"><img src="@/assets/icons/chevron-right.svg" /></div>
      </RouterLink>
      <RouterLink
        v-if="widgetStore.order.paymentMethods?.eft"
        class="flex cursor-pointer m-1 h-14"
        :to="{ name: 'PeachPayment', query: { paymentMethod: 'EFT' } }"
      >
        <div class="self-center p-1 w-14">
          <img src="@/assets/paymentMethods/InstantEft.svg" />
        </div>
        <div class="self-center text-sm grow text-left text-black">Instant EFT</div>
        <div class="self-center"><img src="@/assets/icons/chevron-right.svg" /></div>
      </RouterLink>
      <RouterLink
        v-if="widgetStore.order.paymentMethods?.payAt"
        class="flex cursor-pointer m-1 h-14"
        :to="{ name: 'PayAt' }"
      >
        <div class="self-center p-1 w-14">
          <img src="@/assets/paymentMethods/Cash.svg" />
        </div>
        <div class="self-center text-sm grow text-left text-black">Cash (in-store)</div>
        <div class="self-center"><img src="@/assets/icons/chevron-right.svg" /></div>
      </RouterLink>
      <RouterLink
        v-if="widgetStore.order.state === 'PLACED' && widgetStore.order.paymentMethods?.debiCheck"
        class="flex cursor-pointer m-1 h-14"
        :to="{ name: 'DebiCheck' }"
      >
        <div class="self-center p-1 w-14">
          <img src="@/assets/paymentMethods/DebiCheck.svg" />
        </div>
        <div class="self-center text-sm grow text-left text-black">DebiCheck</div>
        <div class="self-center"><img src="@/assets/icons/chevron-right.svg" /></div>
      </RouterLink>
      <ErrorDisplay
        v-if="!isPaymentMethodAvailable"
        errorMessage=" No payment methods available for this merchant."
        showBackButton
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useWidgetStore } from '@/stores/widget';
import { computed, onMounted } from 'vue';
import { RouterLink, useRouter } from 'vue-router';
import ErrorDisplay from '../../common/ErrorDisplay.vue';

const router = useRouter();
const widgetStore = useWidgetStore();

const isPaymentMethodAvailable = computed(() => {
  return (
    widgetStore.order.paymentMethods?.creditOrDebitCard ||
    widgetStore.order.paymentMethods?.eft ||
    widgetStore.order.paymentMethods?.payAt
  );
});

const paymentMethodCheck = computed(() => {
  const methods = {
    creditOrDebitCard: widgetStore.order.paymentMethods?.creditOrDebitCard,
    eft: widgetStore.order.paymentMethods?.eft,
    payAt: widgetStore.order.paymentMethods?.payAt,
    debiCheck: widgetStore.order.paymentMethods?.debiCheck,
  };

  // returns a array of truthy values
  const availableMethods = Object.values(methods).filter(Boolean);
  const count = availableMethods.length;

  let route = null;
  if (count === 1) {
    if (methods.creditOrDebitCard) route = { name: 'PeachPayment', query: { paymentMethod: 'CARD' } };
    else if (methods.eft) route = { name: 'PeachPayment', query: { paymentMethod: 'EFT' } };
    else if (methods.payAt) route = { name: 'PayAt' };
    else if (methods.debiCheck) route = { name: 'DebiCheck' };
  }

  return { count, route };
});

onMounted(() => {
  const { count, route } = paymentMethodCheck.value;

  if (count === 1 && route) {
    router.push(route);
  }
});

const back = () => {
  widgetStore.boost.newBoost.deposit = widgetStore.amountDue;
  // Something is adding select payment method to the history stack multiple times.
  if (window.history.state.back && window.history.state.back.includes('paymentMethod')) {
    router.go(-2);
    return;
  }
  router.back();
};
</script>
